import { Box } from '@mui/material';
import ButtonAction from '../../../components/buttons/ButtonAction';
import { AddIcon, EditIcon, TrashOutlineIconWhite } from '../../../components/buttons/IconButtons';
import HeadTittle from '../../../components/HeadTittle';
import StepperTabs from '../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../components/StepperTabs/StepTab';
import { permissionObj } from '../../../Helpers/permission';
import routes from '../../../Routes/routes';
import FineTypes from './FineTypes/FineTypes';
import { TrafficMainApp } from './Functionality/TrafficMainApp';
import Manage from './Manage/Manage';
import { TAB_PERMISSION_TRAFFIC, TABS_TRAFFIC } from './Model/Model';
import TrafficFines from './TrafficFines/TrafficFines';
import ExportDataBtn from "../../../components/buttons/ExportDataBtn";
import React from "react";

/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */
const TrafficMain = () => {
    const {
        DEV,
        navigate,
        permission,
        permissionButtons,
        subView,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        setSubView,
        setSearchElement,
        searchElement,
        handleCreate,
        showFinesModal,
        setShowFinesModal,
        handleDelete,
        modified,
        finesSubviewRef,
        handleUpdate,
        selectedInnerView,
        handleStepSelectedInnerView,
        search, setSearch,
        bodyForExport, setBodyForExport,
        criteria, setCriteria,
        moduleId, setModuleId,
        option, setOption,
        fineType
    } = TrafficMainApp();


    if (
        !DEV &&
        !permission?.includes(permissionObj?.WEB_FINE_TYPE_READ) &&
        !permission?.includes(permissionObj?.WEB_TRAFFIC_DASHBOARD_GEOFENCES_READ) &&
        !permission?.includes(permissionObj?.WEB_TRAFFIC_DASHBOARD_FINES_READ) &&
        !permission?.includes(permissionObj?.WEB_TRAFFIC_USERS_READ) &&
        !permission?.includes(permissionObj?.WEB_TRAFFIC_MANAGE_FINES_READ) &&
        !permission?.includes(permissionObj?.WEB_TRAFFIC_MANAGE_GEOFENCES_READ)
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'traffic_main_system'}>
                <Box className='d-flex gap-2 justify-content-end align-items-center mb-2'>

                    {permissionButtons(TAB_PERMISSION_TRAFFIC(subView, selectedInnerView).EXPORT) && <>
                        {
                            search ? (//Advanced search
                                <ExportDataBtn
                                    id="btn_tm_export"
                                    moduleId={moduleId}
                                    body={criteria}
                                    search={search}
                                    option={option}
                                />
                            ) : (
                                <ExportDataBtn // Simple search
                                    id="btn_tm_export"
                                    moduleId={moduleId}
                                    body={bodyForExport}
                                    option={option}
                                    search={search}
                                    searchElement={searchElement}
                                />
                            )
                        }
                    </>
                    }

                   {permissionButtons(TAB_PERMISSION_TRAFFIC(subView, selectedInnerView).CREATE) && (
                        <ButtonAction
                            id='btn_tm_add'
                            name={'create'} className='btn-icon-add'
                            Icon={AddIcon}
                            onClick={() => handleCreate(activeStep)}
                        />
                    )}
                    {permissionButtons(TAB_PERMISSION_TRAFFIC(subView).UPDATE) && (
                        <ButtonAction
                            id='btn_tm_update'
                            name={'update'}
                            disabled={false}
                            className={'btn-icon-edit'}
                            Icon={EditIcon}
                            onClick={() => handleUpdate()}
                        />
                    )}
                    {permissionButtons(TAB_PERMISSION_TRAFFIC(subView).DELETE) && (
                        <ButtonAction
                            id='btn_tm_delete'
                            name='delete'
                            className='btn-icon-delete'
                            Icon={TrashOutlineIconWhite}
                            onClick={() => handleDelete()}
                            disabled={activeStep === TABS_TRAFFIC.FINES_TYPES.INDEX && fineType.selectForDelete.length === 0}
                        />
                    )}
                </Box>
            </HeadTittle>

            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => { }}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_TRAFFIC.TRAFFIC_FINES.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_TRAFFIC.TRAFFIC_FINES.INDEX && (
                        <TrafficFines
                            subView={subView}
                            setSubView={setSubView}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            showFinesModal={showFinesModal}
                            setShowFinesModal={setShowFinesModal}
                            selectedInnerView={selectedInnerView}
                            handleStepSelectedInnerView={handleStepSelectedInnerView}
                            setCriteria={setCriteria}
                            setBodyForExport={setBodyForExport}
                            setSearch={setSearch}
                            setModuleId={setModuleId}
                            setOption={setOption}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_TRAFFIC.MANAGE.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_TRAFFIC.MANAGE.INDEX && (
                        <Manage
                            subView={subView}
                            setSubView={setSubView}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            modified={modified}
                            finesSubviewRef={finesSubviewRef}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_TRAFFIC.FINES_TYPES.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_TRAFFIC.FINES_TYPES.INDEX && <FineTypes/>}
                </StepTab>
            </StepperTabs>
        </>
    );
};

export default TrafficMain;
